var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('webshopNavbar'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('closedShopModal'),(
      _vm.oldOrder &&
      _vm.oldOrder.id &&
      _vm.$router.currentRoute.name !== 'order-redirect'
    )?_c('oldOrderModal',{attrs:{"order":_vm.oldOrder}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }